import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import ChampionTipsForm from './ChampionTipsForm';
import axios from "axios";
import moment from 'moment';


export default class ChampionTipsItem extends Component {

  constructor(props) {
    super(props);
    this.state = {
      champions: null,
      patch: 8.4,
      data: null,
      date: null,
      error: null,
    };
  }
  componentDidMount() {
    const { id } =  this.props.params;
    axios.get('https://beta.iesdev.com/api/lolstats/patches/latest').then(response => {
      return response.data.data.patch;
    }).then(patch => {
      this.setState({ patch })
      return axios.get(`https://beta.iesdev.com/api/ddragon/${patch}.1/data/en_US/champion.json`)
    }).then(response => {
      this.setState({champions: response.data.data})
    });
    axios.get(`https://beta.iesdev.com/api/championtips/${id}`).then(response => {
      this.setState({ data: response.data.data });
    }).catch((error) => {
      this.setState({ data: {} });
    })
  }

  render() {
    const { id } =  this.props.params
    const { champions, patch, data, date, error} = this.state;
    if (!champions || !data) return <h1>loading</h1>
    const keys = Object.keys(champions);
    const key = keys.find(key => champions[key].key === id);

    return (
      <div style={{marginTop: 50, marginBottom: 50}}>
        <div style={{flexDirection: 'row', display: 'flex', alignItems: 'center'}}>
          <img
            style={{ width: 64, height: 64, borderRadius: 4, marginRight: 12 }}
            src={`http://ddragon.leagueoflegends.com/cdn/${this.state.patch}.1/img/champion/${key}.png`}
          />
          <div>
            <div style={{fontSize: 24, fontWeight: 'bold'}}>{champions[key].name}</div>
            <div style={{fontSize: 14}}>Previous Edit: {data.last_updated_patch || 'Never'}</div>
            <div style={{fontSize: 14, color: 'rgba(0,0,0,0.5)'}}>Patch on PBE: {patch}</div>
          </div>
        </div>
        <ChampionTipsForm initialValues={data.tips || {}} onSubmit={(item) => {
          const insights = item.insights;
          const strengths = item.strengths;
          const weaknesses = item.weaknesses;
          const tips = {insights, strengths, weaknesses};
          const champion_tip = {tips , last_updated_patch: patch, champion_id: id };
          console.log(champion_tip)
          return axios.patch(`https://beta.iesdev.com/api/championtips/${id}`, {champion_tip}).then((response) => {
            this.setState({ data: response.data.data, date: moment() });
          }).catch((error) => {
            this.setState({ error })
          });
        }}/>
        { date && <div style={{fontSize: 14, color: 'rgba(0,0,0,0.5)', marginTop: 8}}>Saved on {date.format('MMMM Do YYYY, h:mm:ss a')}</div> }
        { error && <div style={{fontSize: 14, color: 'rgba(0,0,0,0.5)', marginTop: 8}}>Issue with Saving. Contact Jonathan Lin Plox</div> }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/cms/tips/ChampionTipsItem.js